export const ATOMIC_EXCHANGE_SLIPPAGE = '0.01';
